import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { environment } from "../../../../environments/environment";
import { Service } from "../../../models/service";
import { ServiceControllerService } from "../../../services/service-controller/service-controller.service";
import { Store } from "../../../services/store.service";
import { ExternalServerControllerService } from "../../../services/service-controller/external-server-controller.service";
import { SystemPropertiesControllerService } from "../../../services/system-settings/system-properties-controller.service";
import { ExternalServer } from "../../../models/external-server";
import {TranslatedBaseError} from "../TranslatedBaseError";
import {TranslateService} from "@ngx-translate/core";
import {Context} from "../../../models/context";
import {TutorialBase} from "../../../models/tutorial-base";
import { ServiceProperties } from "../../../models/service-properties";
import { GuideTypesEnum } from "../../../models/guideTypes";
import { ReleaseNotesCreateComponent } from "../../release-notes/release-notes-create/release-notes-create.component";
import { TutorialLayerComponent } from "../../tutorial-layer/tutorial-layer.component";
import * as _ from "lodash";
import { DryRunComponent } from "../../utils/dry-run/dry-run.component";

@Component({
  selector: "app-service-detail",
  templateUrl: "./service-detail.component.html",
  providers: [ToastrService],
})
export class ServiceDetailComponent extends TranslatedBaseError implements OnInit {

  public serviceId: string;

  public path: string;
  public reloadServices = false;
  public publishStatus: string;
  public publishStatusError: string;
  public editMode: boolean = false;
  public isLoading: boolean = false;
  public isInitiating: boolean = true;
  public partALink: string;
  public serviceSavedName: string;
  public externalServers: ExternalServer[] = [];
  public confirmation: boolean = false;
  public externalItem: any;
  public popover: any;
  public dropdown: any;
  public serviceHistory: any[] = [];
  public showReleaseNotesCreation: boolean = false;
  public showReleaseNotesList: boolean = false;
  public showReleaseNotes: boolean = false;
  public requestReleaseNotes: boolean = false;
  public guideTypesOptions = [];
  public guideTypesEnum = GuideTypesEnum;
  @Output() public serviceUpdated = new EventEmitter();
  @Input() public hideServices: boolean = false;
  @Input() public context: Context = new Context();
  @Input() public location: string = null;

  @ViewChild(ReleaseNotesCreateComponent) public releaseNotesCreateComponent: ReleaseNotesCreateComponent;
  @ViewChild(TutorialLayerComponent) public tutorialLayerComponent: TutorialLayerComponent;
  @ViewChild(DryRunComponent) public dryRunComponent: DryRunComponent;

  public hidePreview: boolean = false;
  public defaultMyAccountServiceId: string;

  constructor(private serviceControllerService: ServiceControllerService,
              private externalServerService: ExternalServerControllerService,
              private systemPropertiesControllerService: SystemPropertiesControllerService,
              public store: Store,
              private route: ActivatedRoute,
              private router: Router,
              toastr: ToastrService, public translateService: TranslateService) {
    super(toastr, translateService);
  }

  public openPopover(pop) {
    this.popover = pop;
    if (this.dropdown) {
      this.dropdown.autoclose = false;
    }
    this.confirmation = true;
  }

  public closePopover() {
    this.confirmation = false;
    if (this.dropdown) {
      this.dropdown.autoclose = true;
    }
    if (this.popover) {
      this.popover.hide();
    }
    this.closeDropdown();
  }

  public openDropdown(pop) {
    this.dropdown = pop;
  }

  public closeDropdown() {
    if (this.dropdown) {
      this.dropdown.hide();
    }
  }

  public openRCList() {
    this.showReleaseNotesList = true;
    this.showReleaseNotes = true;
  }

  public openTutorial() {
    if (this.tutorialLayerComponent) {
      this.tutorialLayerComponent.toggleTutorial();
    }
  }

  public openRCCreation() {
    this.showReleaseNotesCreation = true;
    this.showReleaseNotes = true;
  }

  public closeRNdrawer(e) {
    this.showReleaseNotesCreation = false;
    this.showReleaseNotesList = false;
    this.showReleaseNotes = false;
  }

  public saveReleaseNotes(e) {
    this.releaseNotesCreateComponent.save(e);
  }

  public isPreviewPage() {
    return window.location.href.includes("preview2");
  }

  public goSeeService(extUrl: string = null, copy: boolean = false) {
    let lang = this.store.state.common.lang;
    // @ts-ignore
    if (this.translateService._$supportedLangs && this.translateService._$supportedLangs.length > 0 && !this.translateService._$supportedLangs.includes(lang)) {
      // @ts-ignore
      lang = this.translateService._$supportedLangs[0];
    }
    let url;
    if (!environment.USE_NEW_DS) {
      url = environment.E_REGISTRATIONS_URL + lang + "/";
    } else {
      url = environment.E_REGISTRATIONS_URL;
    }
    if (extUrl?.length) {
      url = extUrl + "/";
    }
    // String casting is here to fool TS, cause thee enum is miss used and actual keys are coming from server as values...
    if (!this.context?.service?.isMyAccountPage) {
      // put back url ?attemptAutoLogin=1 at some point
      url += `${environment.USE_NEW_DS ? 'services' : 'services-new'}/${this.serviceId}${environment.USE_NEW_DS ? '' : '?attemptAutoLogin=1'}`;
    }
    if (!copy) {
      window.open(url, "_blank");
    } else {
      navigator.clipboard.writeText(url);
      this.responseSuccessful("Service link copied to clipboard!");
    }
  }

  public ngOnInit() {
    if (environment.HIDE_PREVIEW) {
      this.hidePreview = true;
    }
    if (this.guideTypesEnum) {
      this.guideTypesOptions = Object.keys(this.guideTypesEnum);
    }
    this.getSystemProperties();
    this.loadExternalServers();
    this.route.params.subscribe((params) => {
      this.serviceId = (params.serviceId === "new") ? undefined : params.serviceId;
      this.path = location.pathname;
      if (this.serviceId !== null) {
        this.store.state.common.serviceId = this.serviceId;
        this.loadService();
      } else {
        this.isInitiating = false;
      }
    });
    this.defaultMyAccountServiceId = this.store.state.common.defaultMyAccountServiceId;
    if (!this.defaultMyAccountServiceId) {
      this.getMAServices();
    }
    console.log("--- Context:", this.context);
  }

  public getSystemProperties() {
    this.systemPropertiesControllerService.getServiceProperties().subscribe(
      (data) => {
        if (data?.displaySystemProperties?.find((p) => p.name === "request_release_notes_at_publishing")) {
          this.requestReleaseNotes = data.displaySystemProperties.find((p) => p.name === "request_release_notes_at_publishing")?.enabled;
        }
      },
      (error) => {
        return this.error(this.getMessage(error), "Error getting system properties");
      },
    );
  }

  public getMAServices() {
    this.serviceControllerService.getMyAccountService().subscribe((data) => {
      this.defaultMyAccountServiceId = data.id;
      this.store.state.common.defaultMyAccountServiceId = this.defaultMyAccountServiceId;
    });
  }

  public reloadAllServices(data) {
    this.reloadServices = true;
  }

  public loadExternalServers() {
    this.externalServerService.getExternalServers().subscribe(
      (data: ExternalServer[]) => {
        this.externalServers = data;
      },
      (error) => this.showErrorMessage(error),
    );
  }

  public loadService() {
    if (this.serviceId) {
      this.serviceControllerService.getService(this.serviceId).subscribe(
        (data: Service) => {
          this.context.service = Object.assign(new Service(), data);
          this.store.state.common.serviceName = data.name;
          this.context.service.tutorials = Object.assign(new TutorialBase().tutorials, this.context.service.tutorials);
          // this.defaultMyAccountServiceId = data.isMyAccountPage ? data.id : null;
          if (!this.context.service.tutorials.serviceRegistrations) {
            Object.assign(this.context.service.tutorials, TutorialBase.addProperty("serviceRegistrations"));
          }
          if (!this.context.service.tutorials.serviceRoles) {
            Object.assign(this.context.service.tutorials, TutorialBase.addProperty("serviceRoles"));
          }
          if (!this.context.service.tutorials.serviceBotsData) {
            Object.assign(this.context.service.tutorials, TutorialBase.addProperty("serviceBotsData"));
          }
          if (!this.context.service.tutorials.serviceForms) {
            Object.assign(this.context.service.tutorials, TutorialBase.addProperty("serviceForms"));
          }
          if (!this.context.service.tutorials.serviceBotsDocuments) {
            Object.assign(this.context.service.tutorials, TutorialBase.addProperty("serviceBotsDocuments"));
          }
          if (!this.context.service.tutorials.serviceBotsInternal) {
            Object.assign(this.context.service.tutorials, TutorialBase.addProperty("serviceBotsInternal"));
          }
          if (!this.context.service.tutorials.serviceCertificates) {
            Object.assign(this.context.service.tutorials, TutorialBase.addProperty("serviceCertificates"));
          }
          if (!data.serviceJsonProperties) {
            this.context.service.serviceJsonProperties = new ServiceProperties();
          }
          console.log(this.context.service.serviceJsonProperties);
          if (!this.context.service.serviceJsonProperties.guideType) {
            this.context.service.serviceJsonProperties.guideType = this.guideTypesOptions[2];
          }
          this.serviceSavedName = this.context.service.name;
          this.isInitiating = false;
          this.loadServiceHistory();
        },
        (error) => this.showErrorMessage(error),
      );
    }
  }

  private formatPublisher(publisher) {
    if (publisher !== undefined && publisher !== null) {
      if (publisher.indexOf("(") !== -1) {
        return publisher.slice(0, publisher.indexOf("(") - 1);
      } else {
        return publisher;
      }
    }
  }

  public loadServiceHistory() {
    this.serviceControllerService.getServicesHistoryList(this.context.service.id).subscribe(
      (hist) => {
        this.serviceHistory = _.orderBy(hist, "-date");
        this.serviceHistory.forEach((h) => {
          h.opened = false;
          h.username = this.formatPublisher(h.username);
        });
        console.log(this.context.service, this.serviceHistory);
      },
      (error) => this.showErrorMessage(error),
    );
  }

  public getLastExternalPublish(name: string) {
    const lastPublish = this.serviceHistory.find((h) => {
      return !h.failReason && h.destination && h.destination === name;
    });
    if (lastPublish) {
      return lastPublish.date;
    } else {
      return null;
    }
  }

  public existsExternalPublish() {
    return this.serviceHistory.some((h) => {
      return !h.failReason && h.destination;
    });
  }

  public getLastLocalPublish() {
    const lastPublish = this.serviceHistory.find((h) => {
      return !h.failReason && !h.destination;
    });
    if (lastPublish) {
      return lastPublish.date;
    } else {
      return null;
    }
  }

  public publishService(releaseNote: any, externalServerId: string) {
    if (!this.isLoading) {
      this.confirmation = false;
      this.isLoading = true;
      this.publishStatusError = undefined;
      this.publishStatus = "generating ...";
      const title = releaseNote?.title || null;
      const description = releaseNote?.description || "-";
      const typesOfPublication = releaseNote?.typesOfPublication || [];
      this.serviceControllerService.publishService(this.serviceId, externalServerId, title, description, typesOfPublication).subscribe(
        (data: any) => {
          this.context.service.numberOfPublishes ++;
          this.context.service.active = true;
          this.context.service.lastPublishDate = data.date;
          this.confirmation = false;
          this.publishResponseData(data);
        },
        (error) => {
          this.isLoading = false;
          this.publishStatus = undefined;
          this.publishStatusError = "error with service publish!";
          this.showErrorMessage(error);
          this.serviceControllerService.recoverOrphanConfig(this.serviceId).subscribe(
            (debug) => {
              if (debug.length > 0) {
                this.isLoading = false;
                this.dryRunComponent.openDebug();
                this.showErrorMessage("Please fix the errors before publishing the service.");
              }
            }
          );
          if (this.serviceId) {
            this.serviceControllerService.getService(this.serviceId).subscribe(
              (data: Service) => {
                this.context.service.numberOfPublishes ++;
                this.context.service.lastPublishDate = data.lastPublishDate;
              },
              (innerError) => this.showErrorMessage(innerError),
            );
          }
        },
      );
    }
  }

  public saveTutorial(e) {
    if (e) {
      this.context.service.tutorials.general = e;
      this.updateService();
    }
  }

  public publishResponseData(data: any) {
    this.isLoading = false;
    this.publishStatusError = undefined;
    this.externalItem = null;
    this.publishStatus = data.message;
    this.responseSuccessful(this.publishStatus);
    this.loadServiceHistory();
    this.serviceUpdated.emit();
  }

  public toggleEditMode() {
    this.editMode = !this.editMode;
    if (this.editMode && this.context.service.name.length) {
      this.serviceSavedName = this.context.service.name;
    }
  }

  public cancelEditMode() {
    this.editMode = false;
    this.context.service.name = this.serviceSavedName;
  }

  public submitEdit(event) {
    const ENTER = 13;
    if (event.keyCode === ENTER) {
      if (this.editMode && (this.serviceSavedName !== this.context.service.name) && this.context.service.name.length) {
        this.updateService();
        this.toggleEditMode();
      }
    }
  }

  public saveEdit() {
    if (this.editMode && (this.serviceSavedName !== this.context.service.name) && this.context.service.name.length) {
      this.updateService();
    } else {
      this.context.service.name = this.serviceSavedName;
    }
    this.toggleEditMode();
  }

  public updateService() {
    this.isLoading = true;
    this.serviceControllerService.saveService(this.context.service, null).subscribe(
      (data) => {
        this.isLoading = false;
        this.responseSuccessful("Saved successfully!");
      },
      (error) => {
        return this.showErrorMessage(error);
      },
    );
  }

  public applyItem(item: any): void {
    this.externalItem = item;
  }

  public getSelectedItem(): string {
    if (this.externalItem) {
      return this.externalItem.name;
    } else {
      return "";
    }
  }

}
